import http from '@/services/rest/rest.service';
import { IPaging } from '@/entities/paging.interface';
import { ISearchBody } from '@/entities/search-body.interface';
import { IClickOutListModel } from '@/entities/click-outs/click-out-list-model';
import {ICommonLogsListModel, IGetClickOutsModel, IGetCommonLogsModel} from '@/entities';

export default {
    list(body: IGetCommonLogsModel): Promise<IPaging<ICommonLogsListModel>> {
        return http.post('common-logs/search', body);
    },
    export(body: IGetCommonLogsModel): Promise<void> {
        return http.post('common-logs/download', body);
    }
};
